/** Cache keys of the plan and the statistics; stale after every answer. */
export const learningKeys = {
  all: ['learning'] as const,
  plan: (days: number) => ['learning', 'plan', days] as const,
  stats: ['learning', 'stats'] as const,
  leeches: (deckId?: string) => ['learning', 'leeches', deckId ?? 'all'] as const,
};
